export enum PageViewModes {
  BidPackages = "bidpackages",
  Flash = "flashbidpackages",
}
